@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.linkModalInputWrapper {
  box-sizing: border-box;
  border: 1px solid var(--neutral-10);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 4px 8px;
  height: 38px;
  gap: 6px;
  border-radius: 6px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: var(--light-100);
  box-shadow: 1px 1px 0 0 var(--light-90) inset, 0 2px 12px 0 var(--dark-4);
  @include blur(35px);
}

.linkModalInputWrapper:focus-within {
  box-shadow: inset 0 0 0 2px var(--selected-stroke);
}

.linkModalInputIcon {
  margin-right: 4px;
  fill: $grey-30;
}

.linkModalHiddenText {
  @include inter-regular;
  @include smooth-font-rendering;
  opacity: 0;
  z-index: 0;
  font-size: inherit;
  width: 0;
  height: 21px;
  flex-grow: 1;
}

.inputError {
  background-color: $red-5;
  border: 1px solid $red-50;
  box-shadow: 0px 0px 0px 3px rgba(237, 132, 126, 0.25);
  color: $grey-90;
}

.inputError:focus-within {
  border: 1px solid $red-50;
  box-shadow: 0px 0px 0px 3px rgba(237, 132, 126, 0.25);
}

.linkModalResizingInput {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-left: 2px;
  width: 100%;
}

.emptyState {
  @include md-regular;
  @include smooth-font-rendering;
  color: $gray-40;
  display: flex;
  align-items: center;
  margin-left: 2px;
  margin-right: 2px;
  white-space: nowrap;
}

.visibleWrapper {
  z-index: 1;
}
.linkModalInput {
  @include md-regular;
  @include smooth-font-rendering;
  position: absolute;
  top: 0;
  caret-color: var(--selected-stroke);
  bottom: 0;
  left: 0;
  width: calc(100% - 34px);

  &::placeholder {
    color: var(--dark-40);
  }
}

.updateButton {
  padding: 3px 6px;
  min-height: 20px;
  position: absolute;
  right: 0;
}

.textWithUpdateButton,
.linkModalInputWithButton {
  width: calc(100% - 62px);
}

.linkModalInputEmptyState {
  background: transparent;
}

.errorBackground {
  background-color: $red-5;
}

.inputErrorMessage {
  @include inter-regular;

  color: $red-50;
  margin-top: 4px;
}
